import { isLargeScreen, isNotLargeScreen } from '../../utils/mediaquery-utils';

const IS_HIDDEN = 'isHidden';
const IS_STICKY = 'isHiddenMStickyD';
const DATA_STATE_PRIMARY_TAG = 'hasPrimaryTag';
const DATA_STATE_SECTION_NAV = 'hasSectionNav';

const $globalNav = document.querySelector('.j-global-nav');
const $localMenuTitle = document.querySelector('.j-local-title'); // Inside local nav
const $localFeatured = document.querySelector('.j-local-nav__featured'); // Inside local nav
const $sectionNav = document.querySelector('.j-section-nav-wrapper');
const $sectionNavSubElements = $sectionNav?.querySelectorAll('.j-list-nav');
const $primaryTag = document.querySelector('.j-primary-tag');
const $advList = document.querySelectorAll('.u-sticky');
const navStatePrimary = $primaryTag ? DATA_STATE_PRIMARY_TAG : null;
const navStateSection = $sectionNav ? DATA_STATE_SECTION_NAV : null;

const $navController = $primaryTag || $sectionNav;
const navState = navStatePrimary || navStateSection;

const showArticleLocalMenuTitle = () => {
  !$localMenuTitle.classList.contains('has-visibile') ? $localMenuTitle.classList.add('has-visibile') : null;
};

const hideArticleLocalMenuTitle = () => {
  $localMenuTitle.classList.contains('has-visibile') ? $localMenuTitle.classList.remove('has-visibile') : null;
};

const showLocalFeatured = () => {
  $localFeatured.classList.contains('has-scroll-visible')
    ? $localFeatured.classList.remove('has-scroll-visible')
    : null;
};

const hideLocalFeatured = () => {
  !$localFeatured.classList.contains('has-scroll-visible') ? $localFeatured.classList.add('has-scroll-visible') : null;
};

/**
 * Hide Primary Tag or section menu and show local navigation
 * [Current it is used in HP after Article: article --> HP]
 */
export const hidePrimaryShowLocalWithoutTitle = () => {
  if (isLargeScreen()) {
    $navController ? $navController.setAttribute('data-state', IS_HIDDEN) : null;
    hideArticleLocalMenuTitle();
    showLocalFeatured();
  }
};

/**
 * Show Primary Tag or section menu and hide local navigation
 * [Current it is used in HP after Article: HP --> article]
 */
export const showPrimaryHideLocal = () => {
  if (isLargeScreen()) {
    $navController ? $navController.setAttribute('data-state', IS_STICKY) : null;
    showArticleLocalMenuTitle();
    hideLocalFeatured();
  }
};

export const init = () => {
  const sectionNavHasSubMenuOnMobile = isNotLargeScreen() && Boolean($sectionNavSubElements?.length);
  if ($globalNav && $navController && !sectionNavHasSubMenuOnMobile) {
    $advList.forEach((advContainer) => {
      advContainer.setAttribute('data-state', navState);
    });
  }
};
